import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import distributors from './modules/distributors'
import codes from './modules/codes'
import countries from './modules/countries'
import sku from './modules/sku'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    auth,
    distributors,
    codes,
    countries,
    sku
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js